var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"brandname__joey--text"},[_vm._v("Jo"),_c('span',{staticClass:"brandname__joey--e"},[_vm._v("e")]),_vm._v("y")])
}]

export { render, staticRenderFns }